import { render } from "./onboarding-template.vue?vue&type=template&id=47ef1403&scoped=true"
import script from "./onboarding-template.vue?vue&type=script&lang=js"
export * from "./onboarding-template.vue?vue&type=script&lang=js"

import "./onboarding-template.vue?vue&type=style&index=0&id=47ef1403&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ef1403"]])

export default __exports__